import React from 'react'
import { withRouter } from 'react-router'
import { Helmet } from 'react-helmet'
import { DI } from 'modules'
import page from 'hoc/page'
import { convertPhoneNumberToPhoneLink } from 'helpers/strings'

import 'submodules/responsivestyles/src/less/main.less'
import maintenance from 'submodules/responsivestyles/src/pics/error/maintenance-door.gif'

export class ServerErrorPage extends React.Component {
  render() {
    const strings = this.props.common.strings

    return (
      <div className="page page--error">
        <header className="header header--clear header--error">
          <div className="header-main">
            <div className="error-wrap">
              <div className="header-inner">
                <a href="#" className="header-logo">
                  <span className="header-logo__img header-logo__img--black"></span>
                </a>
              </div>
            </div>
          </div>
        </header>

        <section className="content">
          <Helmet
            htmlAttributes={{
              status: 500,
            }}
          />

          <div className="error-wrap">
            <div className="error-page">
              <div className="error-page__content">
                <span className="error-page__title">
                  {strings['page.server_error.title']}
                </span>
                <p className="error-page__text">
                  {strings['page.server_error.text']}
                </p>
              </div>
              <div className="error-page-columns">
                <div className="error-page__left">
                  <ul className="error-page__contacts">
                    <li className="error-page__contact">
                      <span className="error-page__contact-caption">
                        {strings['page.server_error.client_service']}
                      </span>
                      <div className="error-page__contact-link">
                        <a
                          href={convertPhoneNumberToPhoneLink(
                            strings['page.server_error.client_service_phone']
                          )}
                          className="error-page__contact-tel"
                        >
                          {strings['page.server_error.client_service_phone']}
                        </a>
                      </div>
                      <div className="error-page__contact-link">
                        <a
                          href={`mailto:${strings['page.server_error.client_service_email']}`}
                          className="error-page__contact-email"
                        >
                          {strings['page.server_error.client_service_email']}
                        </a>
                      </div>
                    </li>

                    <li className="error-page__contact">
                      <span className="error-page__contact-caption">
                        {strings['page.server_error.broadcast']}
                      </span>
                      <div className="error-page__contact-link">
                        <a
                          href={convertPhoneNumberToPhoneLink(
                            strings['page.server_error.broadcast_phone']
                          )}
                          className="error-page__contact-tel"
                        >
                          {strings['page.server_error.broadcast_phone']}
                        </a>
                      </div>
                      <div className="error-page__contact-link">
                        <a
                          href={`mailto:${strings['page.server_error.broadcast_email']}`}
                          className="error-page__contact-email"
                        >
                          {strings['page.server_error.broadcast_email']}
                        </a>
                      </div>
                    </li>

                    <li className="error-page__contact">
                      <span className="error-page__contact-caption">
                        {strings['page.server_error.submit']}
                      </span>
                      <div className="error-page__contact-link">
                        <a
                          href={convertPhoneNumberToPhoneLink(
                            strings['page.server_error.submit_phone']
                          )}
                          className="error-page__contact-tel"
                        >
                          {strings['page.server_error.submit_phone']}
                        </a>
                      </div>
                      <div className="error-page__contact-link">
                        <a
                          href={`mailto:${strings['page.server_error.submit_email']}`}
                          className="error-page__contact-email"
                        >
                          {strings['page.server_error.submit_email']}
                        </a>
                      </div>
                    </li>
                    <li className="error-page__contact">
                      <span className="error-page__contact-caption">
                        {strings['page.server_error.press']}
                      </span>
                      <div className="error-page__contact-link">
                        <a
                          href={convertPhoneNumberToPhoneLink(
                            strings['page.server_error.press_phone']
                          )}
                          className="error-page__contact-tel"
                        >
                          {strings['page.server_error.press_phone']}
                        </a>
                      </div>
                      <div className="error-page__contact-link">
                        <a
                          href={`mailto:${strings['page.server_error.press_email']}`}
                          className="error-page__contact-email"
                        >
                          {strings['page.server_error.press_email']}
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="error-page__right">
                  <img
                    className="error-page__img"
                    src={maintenance}
                    alt="maintenance"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default withRouter(page(DI(['videos'])(ServerErrorPage)))
